// Interstitial ad rule names used by Game and Window_giveUp
export const INTERSTITIAL_RULES = {
  EVERY_N: 'everyN',
  OUT_OF_MOVES: 'oom',
  WIN_TWICE_IN_A_ROW: 'winTwice',
  GIVE_UP: 'giveUp',
  TOURNAMENT_WIN: 'tournamentWin',
  GIFT_GAIN: 'giftAds',
};
